import React, { useEffect, useState } from "react";
import "./HelpModal.css";
import { Accordion, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getHelp } from "../../../../features/help/Slice";

function HelpModal({ baseLink, ...props }) {

    const help = useSelector((state)=>state.help.addHelp);
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(getHelp());
    },[dispatch]);


    // const data = [
    //     {
    //         title: "Can I Get Express Delivery?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },
    //     {
    //         title: "Can I Edit My Design?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },
    //     {
    //         title: "Can You Help Me In Designing My Order?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },
    //     {
    //         title: "Do You Ship Internationally?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },

    //     {
    //         title: "Can I Get Express Delivery?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },
    //     {
    //         title: "I Have Payment & Refund Related Queries For This Order",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },
    //     {
    //         title: "Referral Cash Back Is Not Working?",
    //         descn: "We Try To Deliver The Products Purchased From Inkmonk.Com In The Best Condition And In The Fastest Time Possible. Unfortunately, We Do Not Offer Express Delivery Currently"
    //     },

    // ]

    return (
        <>
            <section className="HelpModal modal-holder">
                <Modal
                    {...props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="HelpModal modal-holder"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Help
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <div className="help_main_body">

                            <Accordion defaultActiveKey={0}>

                                {help?.map((item, index) => {
                                    return (
                                        <Accordion.Item eventKey={index}>
                                            <Accordion.Header><p className="help_text">{item?.question}</p></Accordion.Header>
                                            <Accordion.Body>
                                                <div className='answer_div'>

                                                    <p className='help_answer_text'>
                                                        {item?.answers}
                                                    </p>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )
                                })}





                            </Accordion>
                        </div>
                    </Modal.Body>
                </Modal>
            </section>
        </>
    );
}

export default HelpModal;
